<p class="draw-signature__instructions">Use your mouse or finger to draw a signature below.</p>

<app-signature-pad
  [existingSignature]="existingSignatureData"
  [showErrorMessages]="true"
  [mode]="'signature'"
  (cancelSignature)="cancelSignature()"
  (signatureSet)="saveSignature($event)"
></app-signature-pad>
